import * as React from 'react';
import { Edit, useNotify, useGetIdentity, useAuthProvider } from 'react-admin';
import { useParams } from 'react-router-dom';
import { UserTitle, UserForm } from './commons';
import { transformRecord } from './utils';

const UserEdit = () => {
    const notify = useNotify();
    const { id: userId } = useParams();
    const authProvider = useAuthProvider();
    const { identity, isLoading: identityLoading } = useGetIdentity();
    const onSuccess = () => {
        notify(`User updated successfully`);
        if (!identityLoading && userId === identity.id) {
            authProvider.refreshTokens()
            .then(() => {
                notify(`Refresh auth tokens successfully.`, { type: 'success' });
            })
            .catch((error) => {
                notify(`Refresh auth tokens failed: ${error}`, { type: 'error' });
            })
        }
    }
    return (
        <Edit title={<UserTitle />} transform={transformRecord} mutationMode="pessimistic" mutationOptions={{ onSuccess }}>
            <UserForm />
        </Edit >
    )
}

export default UserEdit;
